import {
  SCORE_MAX,
  SCORE_GOOD,
  SCORE_MEDIUM,
  SCORE_POOR,
  SCORE_BAD
} from './conditionColors';
import General_Condition_1 from '../images/motoparts/General_Condition_1.png';
import General_Condition_2 from '../images/motoparts/General_Condition_2.png';
import General_Condition_3 from '../images/motoparts/General_Condition_3.png';
import General_Condition_4 from '../images/motoparts/General_Condition_4.png';
import General_Condition_5 from '../images/motoparts/General_Condition_5.png';
import Brakes_1 from '../images/motoparts/Brakes_1.png';
import Brakes_2 from '../images/motoparts/Brakes_2.png';
import Brakes_3 from '../images/motoparts/Brakes_3.png';
import Brakes_4 from '../images/motoparts/Brakes_4.png';
import Brakes_5 from '../images/motoparts/Brakes_5.png';
import Drive_1 from '../images/motoparts/Drive_1.png';
import Drive_2 from '../images/motoparts/Drive_2.png';
import Drive_3 from '../images/motoparts/Drive_3.png';
import Drive_4 from '../images/motoparts/Drive_4.png';
import Drive_5 from '../images/motoparts/Drive_5.png';
import Tires_1 from '../images/motoparts/Tires_1.png';
import Tires_2 from '../images/motoparts/Tires_2.png';
import Tires_3 from '../images/motoparts/Tires_3.png';
import Tires_4 from '../images/motoparts/Tires_4.png';
import Tires_5 from '../images/motoparts/Tires_5.png';

export const generalConditionImages = {
  [SCORE_MAX]: General_Condition_5,
  [SCORE_GOOD]: General_Condition_4,
  [SCORE_MEDIUM]: General_Condition_3,
  [SCORE_POOR]: General_Condition_2,
  [SCORE_BAD]: General_Condition_1,
};

export const brakesImages = {
  [SCORE_MAX]: Brakes_5,
  [SCORE_GOOD]: Brakes_4,
  [SCORE_MEDIUM]: Brakes_3,
  [SCORE_POOR]: Brakes_2,
  [SCORE_BAD]: Brakes_1,
};

export const tiresImages = {
  [SCORE_MAX]: Tires_5,
  [SCORE_GOOD]: Tires_4,
  [SCORE_MEDIUM]: Tires_3,
  [SCORE_POOR]: Tires_2,
  [SCORE_BAD]: Tires_1,
};

export const driveImages = {
  [SCORE_MAX]: Drive_5,
  [SCORE_GOOD]: Drive_4,
  [SCORE_MEDIUM]: Drive_3,
  [SCORE_POOR]: Drive_2,
  [SCORE_BAD]: Drive_1,
};

